import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router';
import { ConfigContext } from 'context/config';
import { parseCoverUrl } from '../utils';

const MetaTags = ({ data }) => {
  const { REACT_APP_UI_URL } = useContext(ConfigContext);
  const location = useLocation();
  const title = data.headline;
  // const description = data.message;
  const cover = data.thumbnail_url || parseCoverUrl(data.video_url);
  return (
    <Helmet title={title}>
      <meta name="title" content={title} />
      {/*<meta name="description" content={description} />*/}
      <meta property="og:title" content={title} />
      {/*<meta property="og:description" content={description} />*/}
      <meta property="og:url" content={REACT_APP_UI_URL + location.pathname} />
      <meta property="og:image" content={cover} />
      <meta name="twitter:card" content={cover} />
      <meta name="twitter:site" content="@textinchurch" />
      <meta name="twitter:creator" content="@textinchurch" />
      <meta name="twitter:title" content={title} />
      {/*<meta name="twitter:description" content={description} />*/}
      <meta name="twitter:image" content={cover} />
    </Helmet>
  );
};

export default MetaTags;
